module.exports = __webpack_public_path__ + "static/media/CentraleSansBook.3592b554.woff";